
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class SectionH2 extends Vue {}
